<template>
  <div class="register__page">
    <div class="register-input-box">
      <div class="register-input-tip">*为必填项</div>
      <el-form
        :model="dataForm"
        label-position="left"
        :rules="rules"
        ref="dataForm"
        label-width="120px"
        class="dataform-input-box"
      >
        <!-- -->
        <el-form-item label="用户名" prop="loginName">
          <el-input v-model="dataForm.loginName" maxlength="12" clearable></el-input>
          <span class="input-after-tip">字母、数字或中文组成，1-12字符</span>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="dataForm.password" maxlength="16" type="password" clearable></el-input>
          <span class="input-after-tip"></span>
        </el-form-item>
        <el-form-item label="确认密码" prop="repeatPassword">
          <el-input v-model="dataForm.repeatPassword" maxlength="16" type="password" clearable></el-input>
          <span class="input-after-tip"></span>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="dataForm.email" clearable></el-input>
          <span class="input-after-tip">请输入邮箱</span>
        </el-form-item>
        <el-form-item label="真实姓名" prop="userName">
          <el-input v-model="dataForm.userName" clearable></el-input>
          <span class="input-after-tip">请输入真实姓名</span>
        </el-form-item>
        <el-form-item prop="gender">
          <el-radio-group v-model="dataForm.gender">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单位所在省市" prop="unitProvinceCity">
          <el-cascader
            expand-trigger="hover"
            :options="provinceOptions"
            v-model="dataForm.unitProvinceCity"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="单位类型" prop="unitType">
          <el-select v-model="dataForm.unitType" placeholder="请选择" clearable>
            <el-option
              v-for="item in companyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span class="input-after-tip">请选择单位类型</span>
        </el-form-item>
        <el-form-item label="单位详细地址" prop="unitLocation">
          <el-input v-model="dataForm.unitLocation" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactUser">
          <el-input v-model="dataForm.contactUser" clearable></el-input>
          <span class="input-after-tip">请输入联系人姓名</span>
        </el-form-item>
        <el-form-item label="开票注册电话" prop="mobileNumber">
          <el-input v-model.number="dataForm.mobileNumber" clearable></el-input>
          <span class="input-after-tip">请输入开票注册电话</span>
        </el-form-item>
        <el-form-item label="手机号码" prop="phoneNumber">
          <el-input v-model.number="dataForm.phoneNumber" maxlength="11" clearable></el-input>
          <span class="input-after-tip">请输入手机号码</span>
        </el-form-item>
        <el-form-item label="邮政编码" prop="zipCode">
          <el-input v-model="dataForm.zipCode" maxlength="6" clearable></el-input>
          <span class="input-after-tip">请输入邮政编码</span>
        </el-form-item>
        <el-form-item>
          <span class="input-after-tips">请您完善以下开票信息</span>
        </el-form-item>
        <el-form-item>
          <el-radio v-model="dataForm.radio" label="1" class="label01">增值税专用发票</el-radio>
          <el-radio v-model="dataForm.radio" label="2">增值税普通发票</el-radio>
        </el-form-item>
        <el-form-item class="form-itemis">
          <div class="register-inputs" v-if="dataForm.radio==1">
            <el-form
              :model="dataForm"
              label-position="left"
              :rules="rules"
              ref="dataForm"
              label-width="120px"
              class="dataformss"
            >
              <el-form-item label="单位名称" prop="unitName">
                <el-input v-model="dataForm.unitName" clearable></el-input>
              </el-form-item>
              <el-form-item label="账号" prop="account">
                <el-input v-model="dataForm.account" clearable></el-input>
              </el-form-item>
              <el-form-item label="开户行" prop="openAccount">
                <el-input v-model="dataForm.openAccount" clearable></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="address">
                <el-input v-model="dataForm.address" clearable></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input v-model="dataForm.phone" clearable></el-input>
              </el-form-item>
              <el-form-item label="税号" prop="ein">
                <el-input v-model="dataForm.ein" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="register-inputs" v-if="dataForm.radio==2">
            <el-form
              :model="dataForm"
              label-position="left"
              :rules="rules"
              ref="dataForm"
              label-width="120px"
              class="dataform-input-box"
            >
              <el-form-item label="单位名称" prop="unitName">
                <el-input v-model="dataForm.unitName" clearable></el-input>
              </el-form-item>
              <el-form-item label="税号" prop="ein">
                <el-input v-model="dataForm.ein" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-form-item>
        <el-form-item prop="agreement">
          <el-checkbox label name v-model="dataForm.agreement">
            <router-link to="/pc/agreement" target="_blank">我已同意用户协议</router-link>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('dataForm')" plain>立即注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var qs = require("qs");
import { post, get, postRequest } from "@/axios/index";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
export default {
  data() {
    //验证用户名
    const validateLoginName = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    //验证密码
    const validPassword = /^(?=.*[a-zA-Z])(?=.*[~!@#$%^&*?()_+-=;:'",./\|<>])[a-zA-Z~!@#$%^&*?()_+-=;:'",./\|<>]{1,16}$/;
    const validatePassword = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      } 
      else {
        callback();
      }
    };
    //验证再次输入密码，确认密码一致
    const validateRepeatpassword = (rule, value, callback) => {
      if (value != this.dataForm.password) {
        return callback(new Error("您输入的两次密码不一致"));
      } else {
        callback();
      }
    };
    // 验证邮编
    const checkEmail = (rule, value, callback) => {
        console.log(value);
        get("/stkuserregisterinfo/getbyemail", {
          email: value
        }).then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.emailFlag = true;
            callback();
          } else {
            return callback(new Error(res.data.msg));
          }
        });
      // }
    };
    // 验证手机号
    const ruleTel = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
    const checkTel = (rule, value, callback) => {
      if (value == "") {
        return callback(new Error("手机号为空"));
      } else if (!ruleTel.test(value)) {
        return callback(new Error("请确认手机格式是否正确"));
      } else {
        get("/stkuserregisterinfo/getbyphonenumber", {
          phoneNumber: value
        }).then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.telFlag = true;
            callback();
          } else {
            return callback(new Error(res.data.msg));
          }
        });
      }
    };

    return {
      radio: "1", //增值税专用发票和普通发票
      // chen_start
      emailFlag: false,
      telFlag: false,
      // chen_end
      //单位所在省市数据
      provinceOptions: regionData,
      //单位类型
      companyTypeOptions: [
        {
          value: 1,
          label: "事业单位"
        },
        {
          value: 2,
          label: "私企"
        }
      ],
      contact: [],//关联客户
      //表单数据
      dataForm: {
        internalId: "",
        //用户昵称
        loginName: "",
        //密码
        password: "",
        //确认密码
        repeatPassword: "",
        //电子邮箱
        email: "",
        //真实姓名
        userName: "",
        //性别
        gender: "1",
        //单位所在省市选中值
        unitProvinceCity: [],
        //单位类型
        unitType: "",
        //单位详细地址
        unitLocation: "",
        //联系人姓名
        contactUser: "",
        //联系人电话
        mobileNumber: "",
        //联系人手机
        phoneNumber: "",
        //邮编
        zipCode: "",
        //是否同意用户协议
        agreement: "",
        //增值税专用发票和普通发票
        radio: "1",
        //单位名称
        unitName: "",
        //账号
        account: "",
        //开户行
        openAccount: "",
        //地址
        address: "",
        //电话
        phone: "",
        //税号
        ein: ""
      },
      //规则
      rules: {
        loginName: [
          {
            required: true,
            validator: validateLoginName,
            trigger: ["blur"]
          }
        ],
        password: [
          {
            required: true,
            validator: validatePassword,
            trigger: ["blur", "change"]
          }
        ],
        repeatPassword: [
          {
            required: true,
            validator: validateRepeatpassword,
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            validator: checkEmail,
            trigger: ["blur"]
          }
        ],
        userName: [
          {
            required: true,
            message: "请输入真实姓名",
            trigger: "blur"
          }
        ],
        unitProvinceCity: [
          {
            required: true,
            message: "请选择单位所在省市",
            trigger: "change"
          }
        ],
        unitType: [
          {
            required: true,
            message: "请选择单位类型",
            trigger: "change"
          }
        ],
        unitLocation: [
          {
            required: true,
            message: "请选择单位详细地址",
            trigger: "blur"
          }
        ],
        contactUser: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur"
          }
        ],
        phoneNumber: [
          {
            required: true,
            // message: "请输入手机号码",
            validator: checkTel,
            trigger: ["blur"]
          }
        ],

        unitName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur"
          }
        ],
        account: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur"
          }
        ],
        openAccount: [
          {
            required: true,
            message: "请输入开户行",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur"
          }
        ],
        ein: [
          {
            required: true,
            message: "请输入税号",
            trigger: "blur"
          }
        ],
        agreement: [
          {
            required: true,
            message: "请同意用户协议",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    submitForm(dataForm) {
      if (!this.emailFlag) {
        return this.$message({
          type: "warn",
          message: "请确认邮箱是否正确"
        });
      } else if (!this.telFlag) {
        return this.$message({
          type: "warn",
          message: "请确认手机号是否正确"
        });
      } else {
        this.$refs[dataForm].validate(valid => {
          if (!this.dataForm.loginName) {
            return this.$message({
              type: "error",
              message: "请输入用户名"
            });
          }
          if (!this.dataForm.password) {
            return this.$message({
              type: "error",
              message: "请输入密码"
            });
          }
          if (this.dataForm.password != this.dataForm.repeatPassword) {
            return this.$message({
              type: "error",
              message: "两次密码不同"
            });
          }
          if (!this.dataForm.email) {
            return this.$message({
              type: "error",
              message: "请输入电子邮箱"
            });
          }
          if (!this.dataForm.userName) {
            return this.$message({
              type: "error",
              message: "请输入真实姓名"
            });
          }
          if (!this.dataForm.unitType) {
            return this.$message({
              type: "error",
              message: "请选择单位类型"
            });
          }
          if (!this.dataForm.contactUser) {
            return this.$message({
              type: "error",
              message: "请输入联系人"
            });
          }
          console.log(this.dataForm.radio);
          if (this.dataForm.radio == 2) {
            if (!this.dataForm.unitName) {
              return this.$message({
                type: "error",
                message: "请输入单位名称"
              });
            }
            if (!this.dataForm.ein) {
              return this.$message({
                type: "error",
                message: "请输入税号"
              });
            }
          } else {
            if (!this.dataForm.unitName) {
              return this.$message({
                type: "error",
                message: "请输入单位名称"
              });
            }
            if (!this.dataForm.account) {
              return this.$message({
                type: "error",
                message: "请输入账号"
              });
            }
            if (!this.dataForm.openAccount) {
              return this.$message({
                type: "error",
                message: "请输入开户行"
              });
            }
            if (!this.dataForm.address) {
              return this.$message({
                type: "error",
                message: "请输入地址"
              });
            }
            if (!this.dataForm.phone) {
              return this.$message({
                type: "error",
                message: "请输入电话"
              });
            }
            if (!this.dataForm.ein) {
              return this.$message({
                type: "error",
                message: "请输入税号"
              });
            }
          }
          if (!this.dataForm.agreement) {
            return this.$message({
              type: "error",
              message: "请同意用户协议"
            });
          }
          if (valid) {
            const data = {
              loginName: this.dataForm.loginName.toString(),
              password: this.dataForm.password.toString(),
              email: this.dataForm.email.toString(),
              userName: this.dataForm.userName.toString(),
              gender: true,
              unitType: this.dataForm.unitType.toString(),
              unitProvinceCity: this.dataForm.unitProvinceCity.toString(),
              unitLocation: this.dataForm.unitLocation.toString(),
              contactUser: this.dataForm.contactUser.toString(),
              mobileNumber: this.dataForm.mobileNumber.toString(),
              phoneNumber: this.dataForm.phoneNumber.toString(),
              zipCode: this.dataForm.zipCode.toString(),
              radio: this.dataForm.radio.toString(),
              unitName: this.dataForm.unitName.toString(),
              account: this.dataForm.account.toString(),
              openAccount: this.dataForm.openAccount.toString(),
              address: this.dataForm.address.toString(),
              phone: this.dataForm.phone.toString(),
              ein: this.dataForm.ein.toString(),
              internalId: this.dataForm.internalId.toString(),
            };
            console.log(data);
            //注册
            postRequest(
              "/stkuserregisterinfo/insertstkuserregisterinfo",
              data
            ).then(
              response => {
                this.$router.push({ path: "/login" });
              },
              err => {
              }
            );
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.register__page {
  width: 1000px;
  margin: 0 auto;
}
.register-label {
  color: @common-blue;
  font-size: 16px;
  margin: 56px 0 39px 26px;
}

.register-input-tip {
  color: @common-blue;
  font-size: 16px;
  margin: 0 0 30px 0;
}

/deep/.register-input-box {
  padding: 31px;
  background: #fff;
  margin-bottom: 50px;
  .el-input {
    width: 176px;
  }
  .el-form-item__label {
    font-size: 14px;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    color: #333;
  }
}

.invoice-input .el-input {
  width: 100% !important;
}

.input-after-tip {
  color: #666;
  // opacity: 0.5;
  font-size: 14px;
  margin-left: 34px;
}
.input-after-tips {
  color: #353030;
  // opacity: 0.5;
  font-size: 18px;
  margin-left: 34px;
}

.dataform-input-box {
  line-height: 32px;
}
.label01 {
  right: 13%;
}
/deep/.el-radio__label {
  font-size: 16px;
}
.register-inputs {
  margin-left: -15%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/register.vue